export default __webpack_public_path__ + "static/media/a4.7dc0c73b.jpg";